import { FormValidationRule } from "../types";

const invalidAccountNumbers = ["00000000", "12300000"];
const pattern = new RegExp("^\\d{8}$");

const calculateTotal = (multipliers: Array<number>, value: string) => {
    let total = 0;
    multipliers.forEach((multiplier, index) => {
        total += parseInt(value[index]) * multiplier;
    });
    return total;
}

const checkBOIAccountNumber = (value: string): boolean => {
    const aMultipliers = [128, 64, 32, 16, 8, 4, 2, 1];

    return calculateTotal(aMultipliers, value) % 11 === 0;
};

const checkKBCAccountNumber = (value: string): boolean => {
    const aMultipliers = [7, 6, 5, 4, 3, 2, 1];
    const checkDigit = parseInt(value.slice(-1));
    const nTotal = calculateTotal(aMultipliers, value.slice(0, -1));

    return (nTotal % 10) === 0
        ? (nTotal % 10) === checkDigit
        : (10 - (nTotal % 10)) === checkDigit;
};

const isAccountNumber: FormValidationRule = (c, v) => {
    let valid = true;
    if ((c.type === "account_number" || c.field_boi_text_as_account_number) && v) {
        // If no validation type is selected, It's treated as BOI
        const isBOI = c.field_account_number_validation_type_boi || (
            !c.field_account_number_validation_type_boi &&
            !c.field_account_number_validation_type_kbc
        );
        const isKBC = !!c.field_account_number_validation_type_kbc;

        valid = (
            pattern.test(v) &&
            invalidAccountNumbers.indexOf(v) === -1 &&
            ((isBOI && checkBOIAccountNumber(v)) ||
            (isKBC && checkKBCAccountNumber(v)))
        );
    }
    return [valid, c.errorMessage || "Enter a valid account number."];
};

export default isAccountNumber;
